<template>
  <b-container class="pt-5">
    <router-view name="modal"></router-view>
    <b-row>
      <b-col cols="6" md="3" class="mb-3" v-for="app in product.apps" v-bind:key="app.url">
        <router-link :to="{path: '/' + product.url + '/' + app.url + '/' + sectionAndArticleUrl(app.tree)}">
          <b-card
            class="nuiteq-card"
            :title="app.name"
            :img-src="app.icon"
            img-alt="App icon"
            img-top
            tag="article"
            style="max-width: 20rem;"
          >
            <div v-if="$authenticated.value">
              <router-link :to="{path: '/' + product.url + '/' + app.url +'/edit'}">
                <b-button class="nuiteq-button" variant="warning">Edit</b-button>
              </router-link>
              <router-link :to="{path: '/' + product.url + '/' + app.url +'/delete'}">
                <b-button class="nuiteq-button" variant="danger">Delete</b-button>
              </router-link>
            </div>
          </b-card>
        </router-link>
      </b-col>
      <b-col v-if="$authenticated.value" cols="6" md="3">
        <router-link :to="{path: product.url +'/new'}">
          <b-card
            title="Add App"
            img-src="https://cdn2.hubspot.net/hubfs/515431/vectorpaint(2).svg"
            img-alt="Image"
            img-top
            tag="article"
            style="max-width: 20rem;"
            class="mb-2 nuiteq-card add-card"
          ></b-card>
        </router-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Apps',
  data() {
    return {
      product: {},
      path: ''
    };
  },
  metaInfo() {
    return { 
        title: this.product.name + ' | NUITEQ Knowledge Base'
    }
  },
  beforeRouteEnter(to, from, next) {
    let path = to.fullPath;
    path = path.slice(-7);
    path;
    if (path === '/delete') {
      next();
    }
    axios.get(process.env.VUE_APP_BASE_URL + to.path).then(response => {
      if(response.data === 'hasNoApps'){
        next({ path: '/' })
      } else {
        next(vm => {
          vm.setData(response, to.path);
        });
      }
    })
    .catch(function (error) {
      if (error) {
        next({ path: '/404' })
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.apps = null;
    axios.get(process.env.VUE_APP_BASE_URL + this.path).then(response => {
      this.setData(response);
      next();
    });
  },
  methods: {
    setData(product, path) {
      this.product = product.data;
      if (path) {
        this.path = path;
      }
    },
    sectionAndArticleUrl(tree){
      if(tree && tree.length > 0){
        if(tree[0].data.articleId){
          return '0/' + tree[0].data.url
          return 1
        } else {
          return tree[0].data.url + '/' + (tree[0].children.length > 0 ? tree[0].children[0].data.url : '')
        }
      } else {
        return ''
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nuiteq-button {
  width: 100%;
  margin-bottom: 5px;
}
.card-img-top {
  width: 120px;
  margin: auto;
}
.add-card > img:nth-child(1) {
  width: 158px;
}
.card-title {
  text-align: center;
}
.card {
  height: 100%;
  padding-top: 24px;
  transition: all 0.3s ease;
  border: none;
  border: 1px solid rgba(0, 0, 0, 0);
  padding: 1.25rem;
}

.card-body {
  padding-bottom: 2px;
  padding-left: 0px;
  padding-right: 0px;
}

.card:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 30px 0;
  border: 1px solid #ef9743;
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

@media (max-width: 767px) {
  h4 {
    font-size: 1.3rem;
  }
  .card {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 30px 0;
    border: 1px solid #ef9743;
  }
  .card-img-top {
    width: 82px;
    margin: auto;
  }
}
</style>
